import React from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { apiClient } from '../lib/api-client';
import { BrandMark } from '../components/BrandMark';

export const ForgotPasswordPage: React.FC = () => (
  <div className="auth-canvas flex min-h-screen flex-col justify-center px-4 py-12 sm:px-6 lg:px-8">
    <div className="mx-auto w-full max-w-md">
      <div className="flex justify-center"><BrandMark /></div>
      <h1 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-950 dark:text-white">Password recovery</h1>
      <p className="mt-2 text-center text-sm text-muted-foreground">Self-service reset email is not enabled in this deployment.</p>
      <div className="mt-8 rounded-2xl border border-white/80 bg-white/90 p-8 shadow-2xl shadow-indigo-950/10 backdrop-blur dark:border-white/10 dark:bg-card/90">
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-950 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-100">
          Sign in through AuthorizeMe if your organization uses SSO. Otherwise, ask your LogLimit organization owner to restore access. No reset email has been sent.
        </div>
        <a href={apiClient.getSsoStartUrl('/transmission-control')} className="mt-6 block">
          <Button className="w-full">Continue with AuthorizeMe</Button>
        </a>
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm font-semibold text-indigo-600 hover:text-indigo-500 dark:text-indigo-400">Back to sign in</Link>
        </div>
      </div>
    </div>
  </div>
);
